/**
 * Single shared `createConversations` factory instance for the
 * web app.
 *
 * The factory holds a private in-memory reverse index
 * (`msgIdIndex`) and `indexLoaded` flag. Two callers both calling
 * `createConversations(webStorage)` would produce two diverging
 * indexes — a write through one wouldn't show up in the other's
 * lookup. Centralising into one module-scope singleton keeps every
 * service (SSE notification append, dispatch, server-pushed dismiss
 * cleanup) talking to the same factory state.
 *
 * Mirrors the extension's `apps/extension/src/storage/conversations.ts`
 * DI seam, minus the `__resetConversationsForTesting` hook (web has
 * no test cases that exercise the singleton across resets yet — add
 * one alongside the test that needs it).
 */

import { createConversations } from "@reflecto/client-core";
import { webStorage } from "../adapters/storage.web";

export const conversations = createConversations(webStorage);
